import React from 'react';
import {
  OverlayWithText,
  ThemeProvider,
} from '@crm-in-store/crmis-signup-ui-kit';
import { config } from '../config';

const CountryNotSupported = (): JSX.Element => {
  return (
    <ThemeProvider theme={config.tenant}>
      <OverlayWithText text="This country is not supported" />
    </ThemeProvider>
  );
};

export default CountryNotSupported;
